<script setup lang="ts">
  defineProps({
    step: { type: Number, required: true },
    offer: { type: Boolean, required: true },
    processing: { type: Boolean, required: false, default: false },
    order: { type: Object, required: false },
  });
</script>
<template>
  <CartLayoutHeader v-bind="{ step, processing, offer }" />
  <slot />
  <CartLayoutFooter :order="order" />
  <SfToastsManager />
  <SfProgressLoader />
</template>
